<button mat-button class="has-icon is-small" (click)="onButtonClick()">
    <mat-icon class="mat-icon-rtl-mirror" svgIcon="run"></mat-icon>
    {{ 'research.top.icon' | translate }}
</button>
